import { CALENDAR_GRID_MODES_ALL } from '../../../constants/calendarGrid'
import { EMPTY_FUNCTION } from '../../../constants/common'
import { CalendarGrid, useCalendarGrid } from '../../CalendarGrid'
import { Container } from '../Container'

import { getCalendarGridsMockItems } from './CalendarGrids.mock'

function CalendarGrids() {
  const calendar = useCalendarGrid({
    getItems: getCalendarGridsMockItems,
    isEnabled: true,
    modes: CALENDAR_GRID_MODES_ALL,
  })

  return (
    <Container label='Calendar grid example'>
      <CalendarGrid
        calendar={calendar}
        isLoading={calendar.isLoading || calendar.isRefetching}
        onClickEmptyCell={EMPTY_FUNCTION}
        onClickItem={EMPTY_FUNCTION}
      />
    </Container>
  )
}

export default CalendarGrids
